export default __webpack_public_path__ + "static/media/overview.e624417c.png";